import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { COLORS } from '../../theme/themeTokens';

/**
 * The gap between an amount and its ticker on the Operations screens.
 *
 * The amount itself is plain text — the app's keypad does the editing — so a
 * thin bar with toggled opacity stands in for the system caret. The slot is
 * the same width whether it blinks or not, which is the point: the row used
 * to gain the caret's width when the keypad opened, leaving a double gap
 * before the ticker.
 */
const AmountCaret: React.FC<{ active: boolean }> = ({ active }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!active) { return; }
    setVisible(true);
    const id = setInterval(() => setVisible((v) => !v), 500);
    return () => clearInterval(id);
  }, [active]);

  return (
    <View style={styles.slot}>
      <View style={[styles.bar, !(active && visible) && styles.hidden]} />
    </View>
  );
};

const styles = StyleSheet.create({
  // One space at the amount's 16-dp Inter, so the gap the row carries in
  // rest reads as a single space and the caret takes its place rather than
  // widening it.
  slot: { width: 4, alignItems: 'center', justifyContent: 'center' },
  bar: { width: 2, height: 18, backgroundColor: COLORS.textPrimary },
  hidden: { opacity: 0 },
});

export default AmountCaret;
